import { routes } from '@/app/routing/router'
import { NewsView } from './view'

const currentRoute = routes.news

const NewsRoute = {
  route: currentRoute,
  view: NewsView,
}

export { currentRoute, NewsRoute }
